import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { LocalVendedorDTO } from '../../../dto/LocalDTO'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'

interface UserInfoProps {
  local: LocalVendedorDTO
  user: any
}

const UserInfo = ({ local, user }: UserInfoProps) => {
  const [userFoto, setUserFoto] = useState<string | null>(null)

  useEffect(() => {
    if (user.user?.logo) {
      setUserFoto(user.user.logo)
    } else if (local.logo) {
      setUserFoto(local.logo)
    } else {
      setUserFoto(null)
    }
  }, [user, local])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        gap: '15px',
        mb: 3,
        p: 0.5
      }}
    >
      {userFoto && (
        <Box>
          <img src={userFoto} alt={local.nombre} width={70} height="auto" />
        </Box>
      )}

      <Box>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          {local.nombre}
        </Typography>
      </Box>

      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'center' }}>
          <Typography variant="body2">{local.direccion}</Typography>
        </Box>
      </Box>

      <Box>
        <Typography variant="body1" fontWeight={'bold'}>
          {local.cuentaTipoNombre?.replace(/<\/?[^>]+(>|$)/g, '')}
        </Typography>
      </Box>

      {local.virtual && <Typography variant="body1">Solo venta online</Typography>}

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.1rem' }}>
        {local.statusFlags === 'A' ? (
          <SentimentSatisfiedAltIcon color="primary" fontSize="small" sx={{ position: 'relative', top: '2px' }} />
        ) : local.statusFlags === 'R' ? (
          <ErrorOutlineIcon color="error" fontSize="small" sx={{ position: 'relative', top: '2px' }} />
        ) : (
          <HourglassEmptyIcon color="primary" fontSize="small" sx={{ position: 'relative', top: '2px' }} />
        )}
        <Typography variant="body1" color={local.statusFlags === 'R' ? 'error' : 'primary'}>
          <b>
            {local.statusFlags === 'A'
              ? 'Cuenta activa'
              : local.statusFlags === 'R'
              ? 'Cuenta rechazada'
              : 'Cuenta inactiva'}
          </b>
        </Typography>
      </Box>

      {local.observacionEstado && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.1rem' }}>
          <ErrorOutlineIcon fontSize="small" style={{ marginTop: '0.1 rem' }} />
          <Typography variant="body1">{local.observacionEstado}</Typography>
        </Box>
      )}
    </Box>
  )
}

export default UserInfo
